var map = {
	"./creator-header-icon.png": "./images/services/creator-header-icon.png",
	"./developer-header-icon.png": "./images/services/developer-header-icon.png",
	"./digital-header-icon.png": "./images/services/digital-header-icon.png",
	"./marketeer-header-icon.png": "./images/services/marketeer-header-icon.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./images/services recursive ^\\.\\/.*\\-header\\-icon\\.png$";


//////////////////
// WEBPACK FOOTER
// ./images/services ^\.\/.*\-header\-icon\.png$
// module id = ./images/services recursive ^\.\/.*\-header\-icon\.png$
// module chunks = 0